import {
  Button,
  Grid2,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { useMemo, useState } from "react";
import ContactModal from "../../components/ContactModal";
import ArrowForward from "@mui/icons-material/ArrowForward";

const what_are_we_data = [
  {
    title: "Scalable & Future-Ready Solutions",
    description: "Built to grow with your business",
  },
  {
    title: "Data-Driven Insights",
    description: "Helping businesses leverage analytics for smarter decisions",
  },
  {
    title: "Cloud & SaaS Expertis",
    description: "Secure, high-performance, and optimized infrastructure",
  },
  {
    title: "User-Centric Approach",
    description: "Focused on seamless experiences and efficiency",
  },
];

const WebView = ({ openModal, setOpenModal }) => {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "65vh",
          marginBottom: 8,
          gap: 8,
        }}
      >
        <Box
          sx={{
            width: "40%",
            height: "100%",
            backgroundImage: "url(/images/about/about_one.png)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
        <Box
          sx={{
            width: "55%",
            display: "flex",
            flexDirection: "column",
            marginRight: 15,
            paddingTop: 4,
            paddingBottom: 4,
            gap: 4,
          }}
        >
          <Typography
            sx={{
              fontSize: {
                md: "3rem",
                laptop: "3.5rem",
                lg: "4rem",
                xl: "4.25rem",
              },
            }}
            variant="h2"
          >
            Who We Are
          </Typography>
          <Typography
            sx={{
              color: "rgba(255,255,255,0.6)",
              fontFamily: "'inter', sans-serif",
              maxWidth: 750,
              fontSize: {
                md: "0.8rem",
                laptop: "0.8rem",
                lg: "1.225rem",
              },
            }}
            // variant="subtitle1"
          >
            At InfinityHyperCloud, we are committed to delivering{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              innovative digital solutions
            </span>{" "}
            that help businesses scale, optimize, and thrive in an ever-evolving
            digital landscape. Specializing in{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              SaaS development, cloud infrastructure, and data analytics
            </span>
            , we provide businesses with the tools and strategies they need to
            improve efficiency, enhance decision-making, and accelerate growth.
            <br />
            <br />
            Our expertise lies in creating{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              scalable and high-performance software solutions
            </span>
            , ensuring seamless integration, security, and future-proof
            technology. Whether it’s{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              developing cloud-native applications, optimizing infrastructure,
              or providing deep data-driven insights
            </span>
            , we empower organizations to stay ahead of the competition and
            drive long-term success
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "65vh",
          gap: 8,
          marginBottom: 8,
        }}
      >
        <Box
          sx={{
            width: "55%",
            display: "flex",
            flexDirection: "column",
            marginLeft: 15,
            paddingTop: 4,
            paddingBottom: 4,
            gap: 4,
          }}
        >
          <Typography
            sx={{
              fontSize: {
                md: "3rem",
                laptop: "3.5rem",
                lg: "4rem",
                xl: "4.25rem",
              },
            }}
            variant="h2"
          >
            What We Do
          </Typography>
          <Typography
            sx={{
              color: "rgba(255,255,255,0.6)",
              fontFamily: "'inter', sans-serif",
              maxWidth: 750,
              fontSize: {
                md: "0.8rem",
                laptop: "0.8rem",
                lg: "1.225rem",
              },
            }}
            // variant="subtitle1"
          >
            We specialize in{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              SaaS development, cloud transformation, and data analytics
            </span>
            , helping businesses unlock the full potential of their technology
            stack. Our solutions are designed to
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              enhance scalability, optimize performance, and streamline business
              operations
            </span>
            , ensuring that companies can adapt to changing market demands with
            ease.
            <br />
            <br />
            Through{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              advanced data analytics and business intelligence
            </span>
            , we transform raw data into valuable insights, enabling
            organizations to{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              make informed decisions, improve efficiency, and drive sustainable
              growth
            </span>
            . Our cloud solutions are built for{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              security, flexibility, and high availability
            </span>
            , empowering businesses to scale effortlessly while maintaining
            optimal performance.
          </Typography>
        </Box>
        <Box
          sx={{
            width: "40%",
            height: "100%",
            backgroundImage: "url(/images/about/about_two.png)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            alignSelf: "flex-end",
          }}
        />
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 8,
        }}
      >
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 4,
          }}
        >
          <Typography
            variant="h2"
            sx={{
              marginBottom: 4,
              fontSize: {
                md: "3rem",
                laptop: "3.5rem",
                lg: "4rem",
                xl: "4.25rem",
              },
            }}
          >
            What Sets Us Apart?
          </Typography>
          <Grid2
            width="100%"
            container
            spacing={2}
            gap={2}
            sx={{ width: "100%" }}
          >
            {what_are_we_data.map((item, index) => (
              <Grid2 item size={6} key={index}>
                <MenuItem
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2,
                    border: `1px solid ${theme.palette.primary.gray}`,
                    borderRadius: 2,
                    p: 2,
                    maxHeight: 200,
                    height: "100%",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: {
                        md: "1.5rem",
                      },
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: "center",
                      color: theme.palette.primary.gray,
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                      overflowWrap: "break-word",
                      fontWeight: 400,
                      fontSize: {
                        md: "1.2rem",
                      },
                    }}
                  >
                    {item.description}
                  </Typography>
                </MenuItem>
              </Grid2>
            ))}
          </Grid2>
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 12,
          marginTop: 12,
        }}
      >
        <Box
          sx={{
            width: "90%",
            backgroundImage: "url(/images/servicesone/services_bg.png)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-evenly",
              alignItems: "center",
              gap: 4,
              p: 4,
            }}
          >
            <Typography
              variant="h2"
              sx={{
                marginBottom: 4,
                fontSize: {
                  md: "3rem",
                  laptop: "3.5rem",
                  lg: "4rem",
                  xl: "4.25rem",
                },
              }}
            >
              Why Choose Us?
            </Typography>
            <Box>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.6)",
                  fontFamily: "'inter', sans-serif",
                  fontSize: {
                    md: "0.8rem",
                    laptop: "0.8rem",
                    lg: "1.225rem",
                  },
                }}
                textAlign="center"
              >
                We combine{" "}
                <span
                  style={{
                    color: "#fff",
                    opacity: 1,
                  }}
                >
                  technical expertise with a problem-solving mindset
                </span>{" "}
                to deliver future-ready digital solutions that empower
                businesses to scale, adapt, and thrive in an evolving digital
                landscape. Our approach is rooted in{" "}
                <span
                  style={{
                    color: "#fff",
                    opacity: 1,
                  }}
                >
                  innovation, efficiency, and security{" "}
                </span>
                , ensuring that every solution we build aligns with modern
                business needs and long-term success.
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.6)",
                  fontFamily: "'inter', sans-serif",
                  fontSize: {
                    md: "0.8rem",
                    laptop: "0.8rem",
                    lg: "1.225rem",
                  },
                }}
                textAlign="center"
              >
                From{" "}
                <span
                  style={{
                    color: "#fff",
                    opacity: 1,
                  }}
                >
                  scalable SaaS platforms to data-driven analytics
                </span>{" "}
                and high-performance cloud solutions, we help businesses
                transform challenges into opportunities. Our commitment to{" "}
                <span
                  style={{
                    color: "#fff",
                    opacity: 1,
                  }}
                >
                  seamless integration, optimized performance, and user-centric
                  design
                </span>{" "}
                enables companies to maximize efficiency and stay ahead of the
                competition.
              </Typography>
            </Box>
            <Button
              type="submit"
              variant="outlined"
              endIcon={<ArrowForward />}
              href="https://calendar.app.google/yyQ665soutqZzj1H9"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "rgba(255,255,255,0.95)",
                borderColor: "rgba(255,255,255,0.4)",
                px: 3,
                py: 1.25,
                maxWidth: 200,
                textTransform: "none",
                borderRadius: 1,
                "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
              }}
            >
              Schedule a call
            </Button>
          </Box>
        </Box>
      </Box>
      <ContactModal openModal={openModal} setOpenModal={setOpenModal} />
    </>
  );
};

const MobileView = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
          variant="h2"
        >
          Who We Are
        </Typography>
        <Typography
          sx={{
            color: "rgba(255,255,255,0.6)",
            fontFamily: "'inter', sans-serif",
            maxWidth: 400,
            fontSize: {
              xs: "0.8rem",
            },
          }}
          textAlign="center"
        >
          At InfinityHyperCloud, we are committed to delivering{" "}
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            innovative digital solutions
          </span>{" "}
          that help businesses scale, optimize, and thrive in an ever-evolving
          digital landscape. Specializing in{" "}
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            SaaS development, cloud infrastructure, and data analytics
          </span>
          , we provide businesses with the tools and strategies they need to
          improve efficiency, enhance decision-making, and accelerate growth.
          <br />
          <br />
          Our expertise lies in creating{" "}
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            scalable and high-performance software solutions
          </span>
          , ensuring seamless integration, security, and future-proof
          technology. Whether it’s{" "}
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            developing cloud-native applications, optimizing infrastructure
          </span>
          , or providing deep data-driven insights, we empower organizations to
          stay ahead of the competition and drive long-term success
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "450px",
          backgroundImage: "url(/images/about/about_one.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
          variant="h2"
        >
          What We Do
        </Typography>
        <Typography
          sx={{
            color: "rgba(255,255,255,0.6)",
            fontFamily: "'inter', sans-serif",
            maxWidth: 400,
            fontSize: {
              xs: "0.8rem",
            },
          }}
          textAlign="center"
        >
          We specialize in{" "}
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            SASS development, cloud transformation, and data analytics
          </span>
          Sa, helping businesses unlock the full potential of their technology
          stack. Our solutions are designed to{" "}
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            enhance scalability, optimize performance, and streamline business
            operations
          </span>
          , ensuring that companies can adapt to changing market demands with
          ease.
          <br />
          <br />
          Through{" "}
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            advanced data analytics and business intelligence
          </span>
          , we transform raw data into valuable insights, enabling organizations
          to{" "}
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            make informed decisions, improve efficiency, and drive sustainable
            growth
          </span>
          . Our cloud solutions are built for{" "}
          <span
            style={{
              color: "#fff",
              opacity: 1,
            }}
          >
            security, flexibility, and high availability
          </span>
          , empowering businesses to scale effortlessly while maintaining
          optimal performance.
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "450px",
          backgroundImage: "url(/images/about/about_two.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
        }}
      >
        <Typography
          sx={{
            marginBottom: 4,
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
          variant="h2"
        >
          What Sets Us Apart?
        </Typography>
        <Grid2 width="100%" container gap={2}>
          {what_are_we_data.map((item, index) => (
            <Grid2 item size={12} key={index}>
              <MenuItem
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                  border: `1px solid ${theme.palette.primary.gray}`,
                  borderRadius: 2,
                  p: 2,
                  maxHeight: 200,
                  height: "100%",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: {
                      xs: "1rem",
                      sm: "1.25rem",
                      md: "1.5rem",
                    },
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    color: theme.palette.primary.gray,
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    fontSize: {
                      xs: "0.8rem",
                      sm: "1rem",
                      md: "1.2rem",
                    },
                  }}
                >
                  {item.description}
                </Typography>
              </MenuItem>
            </Grid2>
          ))}
        </Grid2>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: "url(/images/servicesone/services_bg.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          p: 4,
          gap: 4,
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
          }}
        >
          Why Choose Us?
        </Typography>
        <Box
          sx={{
            padding: 1,
            width: "80%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              color: "rgba(255,255,255,0.6)",
              fontFamily: "'inter', sans-serif",
              maxWidth: 400,
              fontSize: {
                xs: "0.8rem",
              },
            }}
            textAlign="center"
          >
            We combine{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              technical expertise with a problem-solving mindset
            </span>{" "}
            to deliver future-ready digital solutions that empower businesses to
            scale, adapt, and thrive in an evolving digital landscape. Our
            approach is rooted in{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              innovation, efficiency, and security
            </span>{" "}
            , ensuring that every solution we build aligns with modern business
            needs and long-term success.
          </Typography>
        </Box>
        <Box
          sx={{
            padding: 1,
            width: "80%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              color: "rgba(255,255,255,0.6)",
              fontFamily: "'inter', sans-serif",
              maxWidth: 400,
              fontSize: {
                xs: "0.8rem",
              },
            }}
            textAlign="center"
          >
            From{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              scalable SaaS platforms to data-driven analytics
            </span>{" "}
            and high-performance cloud solutions, we help businesses transform
            challenges into opportunities. Our commitment to{" "}
            <span
              style={{
                color: "#fff",
                opacity: 1,
              }}
            >
              seamless integration, optimized performance, and user-centric
              design
            </span>{" "}
            enables companies to maximize efficiency and stay ahead of the
            competition.
          </Typography>
        </Box>
        <Button
          href="https://calendar.app.google/yyQ665soutqZzj1H9"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            textTransform: "none",
            border: `1px solid ${theme.palette.primary.gray}`,
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "rgba(255,255,255,0.95)",
            borderColor: "rgba(255,255,255,0.4)",
            px: 3,
            py: 1.25,
            ml: 3,
            maxWidth: 200,
            borderRadius: 1,
            "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
          }}
          type="submit"
          variant="outlined"
          endIcon={<ArrowForward />}
        >
          <Typography
            sx={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "14px",
            }}
          >
            Schedule a Call
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

const AboutPage = () => {
  const theme = useTheme();
  const [openModal, setOpenModal] = useState(false);

  const isMdScreen = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      {isMdScreen && (
        <WebView openModal={openModal} setOpenModal={setOpenModal} />
      )}
      {!isMdScreen && <MobileView />}
    </>
  );
};

export default AboutPage;
